import SummaryCards from './SummaryCards';
import LowStockAlerts from './LowStockAlerts';
import StockDashboard from './StockDashboard';
import Stockbar from './Stockbar';
import SalesPurchasesReturns from './SalesPurchasesReturns';

function Main2() {
  return (
    <div className="App2">
       <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <SummaryCards />

    <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
          <LowStockAlerts /> 

   </div> 
    <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
           <StockDashboard />

   </div> 
    <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
           <Stockbar />

   </div> 

           <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
           <SalesPurchasesReturns />
           </div> 
                       </div>
 
    </div>
  );
}

export default Main2;
